module.exports = __webpack_public_path__ + "static/media/babysitter-logo-adi.dca11eb0.svg";